// extracted by css-extract-rspack-plugin
export default {"input":"file-button__input___ViPW3","button":"file-button__button___uBBT2 common__button___UCWIz common__bold___ve4Qa"};